export default __webpack_public_path__ + "static/media/img-auth-big.6894928c.jpg";